/*eslint no-undef: 0*/

import * as siteNavigation from '../util/navigation';
import * as util from '../util/util';
import responsiveBgImage from '../util/respbgimages';
import * as slider from '../modules/slider';

export default {
  init() {
    // JavaScript to be fired on all modules

    // Init isTouchDevice
    util.setUserAgent();

    // Init toggleTouchDeviceClasses
    util.toggleTouchDeviceClasses();

    // Init mobileMenu, mobileSubmenu
    siteNavigation.mobileMenu();
    siteNavigation.mobileSubmenu();

    // Init responsiveBgImage
    responsiveBgImage();

    // Init fourItemsCarousel
    slider.fourItemsCarousel();

    // Init logosCarousel
    slider.logosCarousel();

    // Init mobileSlider
    slider.mobileSlider();

    // Init slider
    slider.slider();

    // Init disableBSDropdownAutoClose
    util.disableBSDropdownAutoClose();

    // Init addNewTabMessage
    util.addNewTabMessage();

    // Init inputPlaceholderToggle
    util.inputPlaceholderToggle();

    // Init gravityFormActions
    util.gravityFormActions();

    // Init addScrollbarClass
    util.addScrollbarClass();

    // Init activateResizeHandler
    util.activateResizeHandler();


    // == Window resize actions
    let resizeTimer = null;

    window.addEventListener('resize', () => {
      if (resizeTimer !== null) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        // re-init addScrollbarClass
        util.addScrollbarClass();

        // Init mobileSlider
        slider.mobileSlider();
      }, 66);
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after the init JS

    /**
     * Add custom class to the  root element
     * @link https://github.com/dimsemenov/Magnific-Popup/issues/441
     * @type {{close: $.magnificPopup.defaults.callbacks.close, open: $.magnificPopup.defaults.callbacks.open}}
     */

    // $.magnificPopup.defaults.callbacks = {
    //   open: function () {
    //     document.documentElement.classList.add('mfp-open');
    //   },
    //   close: function () {
    //     document.documentElement.classList.remove('mfp-open');
    //   },
    // };
    //
    // // Init maginificPopupVideo
    // maginificPopupVideo();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js